import { leadingZero } from '@vkontakte/vkjs';

export function formatTime(seconds: number) {
  // Клиент может сгенерировать аудио с дробной секундой, а бекенд их округляет,
  // чтобы не было разных восприятий, округляем секунды и на клиенте
  const roundedSeconds = Math.round(seconds);

  const minutes = Math.floor(roundedSeconds / 60);
  const otherSeconds = roundedSeconds % 60;

  return `${leadingZero(minutes)}:${leadingZero(otherSeconds)}`;
}
